const StickyTemplate = {};

StickyTemplate.templates = {};

StickyTemplate.loadHTML = function (name, html) {
  var $ = window.$;

  var template = StickyTemplate.templates[name];

  if (!template) {
    template = StickyTemplate.templates[name] = { name: name };
  }

  var $jq = $(html);

  $jq.find('[data-sticky-template]').each(function () {
    var $sub = $(this);
    $sub.remove();
    var subName = $sub.data('sticky-template');
    $sub.removeAttr('data-sticky-template');
    StickyTemplate.loadHTML(subName, $sub.get(0).outerHTML);
  });

  const loadedHtml = $jq.get(0).outerHTML;

  template.loaded = true;
  template.html = loadedHtml;
  template.$jQuery = $jq;
};

StickyTemplate.getJQuery = StickyTemplate.getJQ = StickyTemplate.jQuery = StickyTemplate.jq = function (
  name,
  params,
) {
  var $ = window.$;
  var template = StickyTemplate.templates[name] || null;

  if (!template) {
    return null;
  }

  var html = template.html;
  var anyTokens = false;

  if (params) {
    for (var token in params) {
      if (token.slice(0, 1) !== '%') {
        continue;
      }

      var value = params[token];

      if (value.jquery) {
        value = value.get(0).outerHTML;
      }

      html = html.replace(new RegExp(token, 'g'), value);
      anyTokens = true;
    }
  }

  var $jq;

  if (anyTokens) {
    $jq = $(html);
  } else {
    $jq = template.$jQuery.clone();
  }

  if (params) {
    StickyTemplate.setParams($jq, params);
  }

  return $jq;
};

StickyTemplate.setParams = StickyTemplate.params = function ($jq, params) {
  for (var selector in params) {
    if (selector.slice(0, 1) === '%') {
      continue;
    }

    var value = params[selector];

    if (value == null) {
      value = '';
    }

    var selectorParts = selector.split(/\$/g);

    selector = selectorParts[0];

    var attribute = null;

    if (selectorParts.length > 1) {
      attribute = selectorParts[1];
    }

    var $targets = $jq.find(selector).addBack(selector);

    if (attribute) {
      $targets.attr(attribute, value);
    } else if (value.jquery) {
      $targets.empty().append(value);
    } else {
      $targets.text(value);
    }
  }
};

StickyTemplate.getElement = StickyTemplate.element = function (name, params) {
  var $jq = StickyTemplate.jq(name, params);

  if ($jq) {
    return $jq.get(0);
  } else {
    return null;
  }
};

StickyTemplate.getHTML = StickyTemplate.html = function (name, params) {
  var element = StickyTemplate.element(name, params);

  if (element) {
    return element.outerHTML;
  } else {
    return null;
  }
};

StickyTemplate.isLoaded = function (name) {
  if (name) {
    return StickyTemplate.templates[name].loaded;
  } else {
    for (var name_ in StickyTemplate.templates) {
      if (!StickyTemplate.templates[name_].loaded) {
        return false;
      }
    }

    return true;
  }
};

StickyTemplate.stripName = function (str_) {
  let str = str_.split('/').pop();
  str = str.split('.')[0];
  return str;
};

export default StickyTemplate;
